import React, { useState, useEffect } from "react";
import useApi from "../../hooks/useApi";
import useApp from "../../hooks/useApp";
import { Form, InputGroup, Row, Col } from "react-bootstrap";
import Select from "react-select";
import DatePicker from "react-datepicker";
import moment from "moment";
import { CSVLink } from "react-csv";
import Table from "react-bootstrap/Table";

export const CommissionPaidReport = () => {
  const { api, auth } = useApi();
  const { convertCurrency } = useApp();
  const [startDate] = useState(new Date());
  const [endDate] = useState(new Date());
  const [dropDowns, setDropDowns] = useState({});
  const [filter, setFilter] = useState({ year: startDate });
  const [report, setReport] = useState([]);
  const [reportGroup, setReportGroup] = useState({});

  const getDropDowns = async (models) => {
    try {
      const { data } = await api.list(`/dropdowns`, models);
      return data;
    } catch (error) {
      console.error(error);
    }
  };

  const onGenerateReport = async (e) => {
    e.preventDefault();
    try {
      const filterData = {
        ...filter,
        policyCurrency: filter?.policyCurrency?.value || "",
      };
      const url = `/reports/commission-paid`;
      const { data } = await api.getAll(url, filterData, true);
      let dataGroupByCurrency = {};
      data.forEach((element) => {
        if (!element.currency) {
          element.currency = "GHS";
        }
        if (dataGroupByCurrency[element?.currency]) {
          dataGroupByCurrency[element?.currency].push(
            Number(element?.value || 0)
          );
        } else {
          dataGroupByCurrency[element?.currency] = [];
          dataGroupByCurrency[element?.currency].push(
            Number(element?.value || 0)
          );
        }
      });

      setReportGroup(dataGroupByCurrency);
      setReport(data);
    } catch (error) {
      console.log(error);
    }
  };

  const headers = [
    { label: "Date", key: "createdAt" },
    { label: "Commission", key: "value" },
    { label: "Currency", key: "currency" },
    { label: "Policy Number", key: "ClientPolicy.policyNumber" },
    { label: "Policy Title", key: "ClientPolicy.title" },
  ];

  const csvReport = {
    data: report,
    headers: headers,
    filename: "commissions_paid_report.csv",
  };

  return (
    <>
      <Form
        onSubmit={onGenerateReport}
        autoComplete="off"
        id="filterForm"
        className="mb-3"
      >
        <div className="card h-100">
          <fieldset>
            <div className="card-body">
              <div>
                <Row className="mb-3">
                  <Col sm={12} md={6}>
                    <Form.Group>
                      <Form.Label className="text-primary">Year</Form.Label>
                      <DatePicker
                        dateFormat="yyyy"
                        showYearPicker
                        showPopperArrow={false}
                        id="effective-date-year"
                        className="form-control"
                        selected={filter?.year || ""}
                        onChange={(date) =>
                          setFilter({ ...filter, year: date })
                        }
                        isClearable
                        placeholderText=""
                      />
                    </Form.Group>
                  </Col>
                  <Col sm={12} md={6}>
                    <Form.Group>
                      <Form.Label className="text-primary">Quarter</Form.Label>
                      <DatePicker
                        renderCustomHeader={({ date }) => (
                          <div
                            style={{
                              margin: 10,
                              display: "flex",
                              justifyContent: "center",
                            }}
                          ></div>
                        )}
                        dateFormat="QQQ"
                        showQuarterYearPicker
                        showPopperArrow={false}
                        id="effective-date-quarter"
                        className="form-control"
                        selected={filter?.quarter || ""}
                        onChange={(date) =>
                          setFilter({ ...filter, quarter: date })
                        }
                        isClearable
                        placeholderText=""
                      />
                    </Form.Group>
                  </Col>
                  <Col sm={12} md={6}>
                    <Form.Group>
                      <Form.Label className="text-primary">Month</Form.Label>
                      <DatePicker
                        renderCustomHeader={({ date }) => (
                          <div
                            style={{
                              margin: 10,
                              display: "flex",
                              justifyContent: "center",
                            }}
                          ></div>
                        )}
                        dateFormat="MMMM"
                        showMonthYearPicker
                        showFullMonthYearPicker
                        showPopperArrow={false}
                        id="effective-date-month"
                        className="form-control"
                        selected={filter?.month || ""}
                        onChange={(date) =>
                          setFilter({ ...filter, month: date })
                        }
                        isClearable
                        placeholderText=""
                      />
                    </Form.Group>
                  </Col>
                  <Col sm={12} md={6}>
                    <Form.Group>
                      <Form.Label className="text-primary">
                        Policy Currency
                      </Form.Label>
                      <Select
                        id="currency"
                        options={[
                          { label: "GHS", value: "GHS" },
                          { label: "USD", value: "USD" },
                        ]}
                        onChange={(selectedOption) =>
                          setFilter({
                            ...filter,
                            policyCurrency: selectedOption,
                          })
                        }
                        value={filter?.policyCurrency || "GHS"}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col sm={12} md={6}>
                    <Form.Group>
                      <Form.Label className="text-primary">
                        Start Date
                      </Form.Label>
                      <DatePicker
                        dateFormat="dd/MM/yyyy"
                        showMonthDropdown
                        showPopperArrow={false}
                        id="effective-date"
                        className="form-control"
                        selected={filter?.startDate}
                        onChange={(date) =>
                          setFilter({ ...filter, startDate: date })
                        }
                        isClearable
                        placeholderText=""
                      />
                    </Form.Group>
                  </Col>
                  <Col sm={12} md={6}>
                    <Form.Group>
                      <Form.Label className="text-primary">End Date</Form.Label>
                      <DatePicker
                        dateFormat="dd/MM/yyyy"
                        showMonthDropdown
                        showPopperArrow={false}
                        id="effective-date"
                        className="form-control"
                        selected={filter?.endDate}
                        onChange={(date) =>
                          setFilter({ ...filter, endDate: date })
                        }
                        isClearable
                        placeholderText=""
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </div>
            </div>
          </fieldset>
          <div className="card-footer">
            <div className="d-flex justify-content-between">
              <button className={"btn btn-primary"} type="submit">
                Generate Report
              </button>
            </div>
          </div>
        </div>
      </Form>
      {report?.length > 0 && (
        <>
          {Object.keys(reportGroup)?.length > 0 && (
            <div className="card h-100 mb-3">
              <div className="card-header">
                <h1>Summary</h1>
              </div>
              <div className="card-body">
                <Row>
                  {Object.keys(reportGroup).map((currencyGroup) => (
                    <Col
                      sm={12}
                      md={6}
                      className=" mb-2 text-black"
                      key={currencyGroup}
                    >
                      <h1 className="text-primary">{currencyGroup}</h1>
                      <hr />
                      <p>Count: {reportGroup[currencyGroup].length}</p>
                      <p>
                        Total Value:{" "}
                        {convertCurrency(
                          reportGroup[currencyGroup].reduce((a, b) => a + b),
                          currencyGroup
                        )}
                      </p>
                    </Col>
                  ))}
                </Row>
              </div>
            </div>
          )}
          <div className="card h-100">
            <div className="card-header">
              <h1>Report</h1>
            </div>
            <div className="card-body">
              <CSVLink {...csvReport}>Export to CSV</CSVLink>
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <td>Date</td>
                    <td align="right">Commission</td>
                    <td>Currency</td>
                    <td>Policy Number</td>
                    <td>Policy Title</td>
                  </tr>
                </thead>
                <tbody>
                  {report.map((element) => (
                    <tr key={element.id}>
                      <td>{moment(element?.createdAt).format("yyyy-MM-DD")}</td>
                      <td align="right">
                        {convertCurrency(element?.value, element?.currency)}
                      </td>
                      <td>{element?.currency}</td>
                      <td>{element?.ClientPolicy?.policyNumber}</td>
                      <td>{element?.ClientPolicy?.title}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </div>
        </>
      )}
    </>
  );
};
